export default "__VITE_ASSET__CRyoP3tY__"